import { render, staticRenderFns } from "./PrivacyPolicyStatic.vue?vue&type=template&id=79266980&"
import script from "./PrivacyPolicyStatic.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyStatic.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyStatic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports